import {Component, ContentChildren, HostListener, Input, QueryList} from '@angular/core';
import {RcItemLayoutComponent} from './rc-item-layout.component';
import {RcItemDrawerComponent} from './rc-item-drawer.component';

@Component({
    selector: 'lib-rc-items-layout',
    template: `<div [ngClass]="{'container': useContainer}">
    <ng-container *ngFor="let row of rows; let i = index">
        <div class="row">
            <ng-container *ngFor="let item of rowItems(row); let j = index">
                <div [attr.aria-expanded]="isDrawerOpen(row, j)" (click)="itemClicked(item, row, j)" class="col-xs-{{extraSmall}} col-sm-{{smallRow}} col-md-{{mediumRow}} col-lg-{{largeRow}} col-xl-{{extraLargRow}}">
                    <ng-container [ngTemplateOutlet]="item.signleItemContent"></ng-container>
                </div>
            </ng-container>
        </div>
        <div class="row">
            <ng-container *ngFor="let item of rowItems(row); let j = index">
                <div *ngIf="isDrawerOpen(row, j)" class="col-sm-12 col-md-12 col-lg-12">
                    <ng-container [ngTemplateOutlet]="drawers.toArray()[getDrawerByRowAndCol(row, j)].signleItemDrawer"></ng-container>
                </div>
            </ng-container>
        </div>
    </ng-container>
</div>`,
    styles: [``]
})
export class RcItemsLayoutComponent {
    @Input() itemsInExtraSmallRow: number = 1;
    @Input() itemsInSmallRow: number = 2;
    @Input() itemsInMediumRow: number = 3;
    @Input() itemsInLargeRow: number = 4;
    @Input() itemsInExtraLargeRow: number = 6;
    @Input() haveDrawer: boolean = true;
    @Input() useContainer: boolean = true;
    @Input() closeOtherDrawersOnOpening: boolean = true;

    @Input() smW: number = 576;
    @Input() mdW: number = 768;
    @Input() lgW: number = 992;
    @Input() xlW: number = 1200;

    @ContentChildren(RcItemLayoutComponent) items: QueryList<RcItemLayoutComponent>;
    @ContentChildren(RcItemDrawerComponent) drawers: QueryList<RcItemDrawerComponent>;

    @HostListener('window:resize', [''])
    onResize() {
        this.currentWidth = window.innerWidth;
    }

    public currentWidth = window.innerWidth;
    public currentOpenedDrawers: number[] = [];

    constructor() {}

    get rows(): number[] {
        const arr = [];
        for(let i = 0; i < Math.ceil(this.items.length / this.itemsInRow); i++) {
            arr.push(i);
        }
        return arr;
    }

    get itemsInRow(): number {
        if (this.is('xl')) {
            return this.itemsInExtraLargeRow;
        }
        if (this.is('lg')) {
            return this.itemsInLargeRow;
        }
        if (this.is('md')) {
            return this.itemsInMediumRow;
        }
        if (this.is('sm')) {
            return this.itemsInSmallRow;
        }
        return this.itemsInExtraSmallRow;

    }

    get extraSmall(): number{
        return 12 / this.itemsInExtraSmallRow;
    }

    get smallRow(): number{
        return 12 / this.itemsInSmallRow;
    }

    get mediumRow(): number{
        return 12 / this.itemsInMediumRow;
    }

    get largeRow(): number{
        return 12 / this.itemsInLargeRow;
    }
    get extraLargRow(): number {
        return 12 / this.itemsInExtraLargeRow;
    }

    private is(size): boolean {
        switch (size){
            case 'xs':
                return this.currentWidth < this.smW;
            case 'sm':
                return this.currentWidth >= this.smW && this.currentWidth < this.mdW;
            case 'md':
                return this.currentWidth >= this.mdW && this.currentWidth < this.lgW;
            case 'lg':
                return this.currentWidth >= this.lgW && this.currentWidth < this.xlW;
            case 'xl':
                return this.currentWidth >= this.xlW;
        }
        throw new DOMException('Error - unhandled screen size');
    }

    isDrawerOpen(rowIndex, itemIndex): boolean {
        if (!this.haveDrawer) {
            return null;
        }
       return this.currentOpenedDrawers[rowIndex] === itemIndex;
    }

    itemClicked(item, rowIndex, itemIndex): void {
        if (this.currentOpenedDrawers[rowIndex] === itemIndex) {
            this.currentOpenedDrawers[rowIndex] = null;
        } else {
            if (this.closeOtherDrawersOnOpening) {
                this.currentOpenedDrawers = [];
            }
            this.currentOpenedDrawers[rowIndex] = itemIndex;
        }
    }

    rowItems(rowIndex): RcItemLayoutComponent[] {
        return this.items.toArray().slice((rowIndex * this.itemsInRow), (rowIndex + 1) * this.itemsInRow);
    }
    getDrawerByRowAndCol(rowIndex, itemIndex): number {
        return (this.itemsInRow * rowIndex) + itemIndex
    }
}
